export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateRequired = (value) => {
  return value.trim() !== "";
};

export const validatePhone = (phone) => {
  const phoneRegex = /^\d{10,10}$/;
  return phone === "" || phoneRegex.test(phone);
};

export const validateGuestForm = (formData) => {
  const errors = {};

  // Required fields
  if (!validateRequired(formData.first_name)) {
    errors.first_name = "First name is required";
  }
  if (!validateRequired(formData.last_name)) {
    errors.last_name = "Last name is required";
  }

  // Mobile validation
  if (!validateRequired(formData.mobileNo)) {
    errors.mobileNo = "Mobile number is required";
  } else if (!validatePhone(formData.mobileNo)) {
    errors.mobileNo = "Please enter a valid phone number";
  }

  // Email validation
  if (!validateRequired(formData.email)) {
    errors.email = "email is required";
  } else if (!validateEmail(formData.email)) {
    errors.email = "Please enter a valid email";
  }

  // ID Number validation
  if (formData.identityType && !formData.idNumber) {
    errors.idNumber = "ID number is required when identity type is provided";
  }

  return errors;
};

export const isFormValid = (errors) => {
  return Object.keys(errors).length === 0;
};

export const validateFileUpload = (file) => {
  const maxFileSize = 2 * 1024 * 1024;
  const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
  if (file.size > maxFileSize) {
    return "File size must be less than 2 MB.";
  }
  if (!allowedTypes.includes(file.type)) {
    return "Only PDF, JPEG, and PNG files are allowed.";
  }
  return null;
};
